import React, { useState } from 'react';
import ExamHistoryList from './ExamHistoryList';
import ExamReviewDetail from './ExamReviewDetail';

export default function ExamHistoryOrchestrator({ onClose, getToken }) {
  const [reviewExamId, setReviewExamId] = useState(null);

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/80">
      <div className="relative w-full max-w-2xl h-[90vh] mx-4 flex flex-col bg-[#0d1117] border border-[#30363d] rounded-2xl shadow-2xl overflow-hidden">
        {reviewExamId ? (
          <ExamReviewDetail
            examId={reviewExamId}
            getToken={getToken}
            onBack={() => setReviewExamId(null)}
            onClose={onClose}
          />
        ) : (
          <ExamHistoryList
            getToken={getToken}
            onSelectExam={setReviewExamId}
            onClose={onClose}
          />
        )}
      </div>
    </div>
  );
}
